import { render, staticRenderFns } from "./ObservedBehaviorSelector.vue?vue&type=template&id=1f4bd3ea&scoped=true"
import script from "./ObservedBehaviorSelector.vue?vue&type=script&lang=js"
export * from "./ObservedBehaviorSelector.vue?vue&type=script&lang=js"
import style0 from "./ObservedBehaviorSelector.vue?vue&type=style&index=0&id=1f4bd3ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bd3ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4bd3ea')) {
      api.createRecord('1f4bd3ea', component.options)
    } else {
      api.reload('1f4bd3ea', component.options)
    }
    module.hot.accept("./ObservedBehaviorSelector.vue?vue&type=template&id=1f4bd3ea&scoped=true", function () {
      api.rerender('1f4bd3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/three-to-four/components/ObservedBehaviorSelector.vue"
export default component.exports